import "./Questions.css"
import logo from '../img/logo.png'
import { ArrowRight } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
function Questions(){
    const items = [
        { answer: "We create highly engaging augmented and virtual reality solutions." },
        { answer: "Our team builds future-ready experiences beyond today’s trends." },
        { answer: "We collaborate with top brands to deliver impactful projects." }
      ];
    
      const [stages, setStages] = useState(Array(items.length).fill("idle"));
    
      const handleClick = (index) => {
        if (stages[index] !== "idle") return; 
    

        updateStage(index, "moved");
    
        setTimeout(() => {
          updateStage(index, "revealed");
    
          setTimeout(() => {
            updateStage(index, "idle");
          }, 5000);
        }, 2000);
      };
      const updateStage = (index, newStage) => {
        setStages((prev) => {
          const copy = [...prev];
          copy[index] = newStage;
          return copy;
        });
      };
    
    
    return(
        <div className="question-background">
            <div>
<div className="question-card" style={{top:"100px",position:"relative"}}> 
    <div className="question-card-title">Why Creora Developers?</div>
    <p>"Because we don’t just follow trends — we build the next reality."</p>
    <div className="why-list">
        {items.map((item, index) => {
          const stage = stages[index];
          return (
            <div key={index} className="why-item">
           
              {stage !== "revealed" && (
                <button
                  className={`why-btn ${stage === "moved" ? "move-right" : ""}`}
                  onClick={() => handleClick(index)}
                >
                  <ArrowRight size={20} />
                </button>
              )}

      
              <div
                className={`why-line 
                  ${stage === "moved" ? "expanded" : ""} 
                  ${stage === "revealed" ? "revealed" : ""}`}
              >
                <div
                  className={`why-answer ${
                    stage === "revealed" ? "show" : ""
                  }`}
                >
                  {item.answer}
                </div>
              </div>
            </div>
          );
        })}
      </div>
</div>
</div>
<div className="question-info">
<div className="question-info-title">Step into the Experience</div>
<div className="question-info-description">
See how we bring your ideas to life with AR, VR, and Mixed Reality.<br/>From holographic products to immersive training rooms
</div>
<div className="question-video"> 
<video
    src="https://pub-9a8a06fdf1024d2bbcace024d21e6deb.r2.dev/creora/about/LandingPageVideo.mp4"
    width="100%"
    height="600"
    autoPlay
    muted
    loop
    playsInline
  ></video>

</div>
<div className="footer-video">
  <video
    src="https://pub-9a8a06fdf1024d2bbcace024d21e6deb.r2.dev/creora/about/L2.mp4"
    autoPlay
    muted
    loop
    playsInline
  ></video>

  <div className="question-creora">
    <div className="question-logo">
      <img src={logo} alt="logo" />
    </div>
    <div className="question-title-creora">Creora</div>
  </div>
</div>

<a href="/book"><button className="quetion-button">Book an Appoinment </button></a>
</div>
        </div>



    )
}
export default Questions;